<template>
<div>
    <div id="login">
        <div class="login__modal modal-content">
            <login-form />
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import LoginForm from './LoginForm';
import LoginExtra from './LoginExtra';

const name = 'login';
export default {
    name,
    componentName: name,

    components: {
        [LoginForm.name]: LoginForm,
        [LoginExtra.name]: LoginExtra,
    },

    data() {
        return {};
    },

    methods: {},
};
</script>



// WEBPACK FOOTER //
// login/Components/Login.vue